<script>
  import { composeClasses } from '@coldandgoji/utilities'

  export let route

  $: classes = composeClasses( [
    'Page',
  ] )

  $: route = route
</script>

<div 
  class={ classes }
  data-route={ route.path }
>
  <slot></slot>
</div>
